import gql from "graphql-tag";

export const GET_DEAL_PERFORMANCE = gql`
  query deals_performance(
    $business_profile_id: uuid
    $club_profile_id: uuid
    $current_date_time: timestamp
  ) {
    past_deals: deals_aggregate(
      where: {
        business_profile_id: { _eq: $business_profile_id }
        club_profile_id: { _eq: $club_profile_id }
        _or: [
          { manually_end_at: { _is_null: false } }
          { expire_date_time: { _lt: $current_date_time } }
        ]
      }
    ) {
      aggregate {
        count
      }
    }
    active_deals: deals_aggregate(
      where: {
        business_profile_id: { _eq: $business_profile_id }
        club_profile_id: { _eq: $club_profile_id }
        _and: [
          { manually_end_at: { _is_null: true } }
          { expire_date_time: { _gt: $current_date_time } }
        ]
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;
